import styles from './camadas.module.css';

/** Fundo do bloco (grade + brilho verde) que acompanha o scroll. Decorativo; vai como 1º filho da <section>. */
export function CamadasBloco({ variante = 'padrao' }: { variante?: 'padrao' | 'faq' }) {
  return (
    <div className={[styles.camadas, variante === 'faq' ? styles.camadas_faq : undefined].filter(Boolean).join(' ')} aria-hidden='true'>
      <div className={styles.grade} data-m='atmo-grade' />
      <div className={styles.brilho} data-m='atmo-brilho' />
    </div>
  );
}

/** Classes do kit para elementos decorativos. O feixe só roda com `useVisivel` ligado nele e o modo On. */
export const motionClasses = { feixe: styles.feixe } as const;
